module.exports = __webpack_public_path__ + "img/T1.7c5fc2e7.jpg";